import { EnhancedTable } from 'components/enhanced';
import { equipmentLogBookService } from 'features/inventory/equipments/api/equipment-log-book.service';
import { useCallback, useMemo } from 'react';
import { LOGBOOK_COLUMNS } from './columns';

interface EquipmentLogBookTimelineProps {
  equipmentId: number;
}

export const EquipmentLogBookTimeline = ({ equipmentId }: EquipmentLogBookTimelineProps) => {
  const cachedColumns = useMemo(() => LOGBOOK_COLUMNS, []);
  const handleFetchLogBook = useCallback(
    (limit: number, offset: number, searchParams: Record<string, any>) => {
      const { outerParams: _, ...cleanFilters } = searchParams || {};

      return equipmentLogBookService.getLogBook(equipmentId, limit, offset, cleanFilters);
    },
    [equipmentId]
  );

  return (
    <EnhancedTable
      key={equipmentId}
      service={equipmentLogBookService}
      columns={cachedColumns}
      getMethod={handleFetchLogBook}
      disableDelete={true}
    />
  );
};
